import { network } from 'services/network';

import { QueryParams } from 'api/queries/activityCompletionPlan.query';

export const ENDPOINT = 'api/bo/getActivityCompletionPlan';

export const getActivityCompletionPlan = (params: QueryParams) => {
    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
